<template>
  <WsReadDialog
    ref="readDialog"
    :fields="fields"
    :titleKey="titleKey"
    :deletable="deletable"
    :editable="editable"
    :customBtns="customBtns"
    :isCloseScrollTop="isCloseScrollTop"
    :isLoading="isLoading"
    @custom-emit="$_onCustomAction($event)"
    @delete-submit="$_onDeleteSubmit($event)"
    @update="$_onUpdate($event)"
  >
    <template v-slot:content="{modelData}">
      <WsCompareTable
        :fields="fields"
        :modelData="modelData"
        :getValueFunction="getCompareDialogValueFunction"
      />
    </template>
  </WsReadDialog>
</template>
<script>
export default {
  name:'WsReadDialogCompare',
  props: {
    titleKey: String,
    fields: Object,
    deletable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    customBtns: {
      type: Object,
      default: function (){
        return {}
      }
    },
    getCompareDialogValueFunction: {
      type: Object,
    },
    isCloseScrollTop: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods:{
    $_onDeleteSubmit($event) {
      this.$emit("delete-submit", $event);
    },
    $_onUpdate($event) {
      this.$emit("update", $event);
    },
    open(item) {
      this.$refs.readDialog.open(item)
    },
    close() {
      this.$refs.readDialog.close();
    },
    $_onCustomAction($event){
      this.$emit('custom-emit', $event)
    }
  }
}
</script>